import { getLocaleString } from './func.js';
import { useDate } from '@/composables/useDate.js';

const { daysDiff, parse, startOf } = useDate();

export function daysBetweenDateTimes(startDateTime, endDateTime) {
    let start = startOf(startDateTime, 'day');
    let end = startOf(endDateTime, 'day');

    return daysDiff(end, start);
}

export default {
    methods: {
        daysBetweenDateTimes(startDateTime, endDateTime) {
            let start = startOf(startDateTime, 'day');
            let end = startOf(endDateTime, 'day');

            return daysDiff(end, start);
        },
        daysBetweenDates(startDate, endDate) {
            let start = startOf(startDate);
            let end = typeof endDate === 'string' ? parse(endDate) : endDate;

            return daysDiff(end, start);
        },
        dayString(date, comparison) {
            return this.$t('Day') + ' ' + (this.daysBetweenDates(date, comparison) + 1);
        },
        dayStringRange(startDate, endDate, comparison) {
            if (startDate === endDate) {
                return this.$t('Day') + ' ' + (this.daysBetweenDates(startDate, comparison) + 1);
            } else {
                return (
                    this.$t('Day') +
                    ' ' +
                    (this.daysBetweenDates(startDate, comparison) + 1) +
                    ' - ' +
                    this.$t('Day') +
                    ' ' +
                    (this.daysBetweenDates(endDate, comparison) + 1)
                );
            }
        },
        numericDate(date, locale) {
            const dateOptions = { year: '2-digit', month: '2-digit', day: '2-digit' };
            let localDate = new Date(date).toLocaleDateString(locale || getLocaleString(), dateOptions);
            return (localDate = localDate.replace('.', '/').replace('.', '/'));
        },
        numericDateRange(startDate, endDate) {
            if (startDate === endDate) {
                return this.numericDate(startDate);
            } else {
                return this.numericDate(startDate) + ' - ' + this.numericDate(endDate);
            }
        },
        numericDateTimeRange(startDate, endDate) {
            if (startDate === endDate) {
                return this.numericDateTime(startDate);
            } else {
                return this.numericDateTime(startDate) + ' - ' + this.numericDateTime(endDate);
            }
        },
        numericDateTime(date, locale) {
            const dateOptions = { year: '2-digit', month: '2-digit', day: '2-digit' };
            const timeOptions = { hour: '2-digit', minute: '2-digit' };
            let localDate = new Date(date).toLocaleDateString(locale || getLocaleString(), dateOptions);
            let localTime = new Date(date).toLocaleTimeString(locale || getLocaleString(), timeOptions);
            localDate = localDate.replace('.', '/').replace('.', '/');
            localTime = localTime.replace('.', ':');
            return localDate + ', ' + localTime;
        },
        numericTime(date, locale) {
            const timeOptions = { hour: '2-digit', minute: '2-digit' };
            let localTime = new Date(date).toLocaleTimeString(locale || getLocaleString(), timeOptions);
            return localTime.replace('.', ':');
        },
        longDate(date, locale) {
            const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            let localDate = new Date(date).toLocaleDateString(locale || getLocaleString(), dateOptions);
            return localDate;
        },
        numericDateTimeWithWeekDay(date) {
            const dateOptions = { year: '2-digit', month: '2-digit', day: '2-digit' };
            const weekdayOptions = { weekday: 'long' };
            let localDate = new Date(date).toLocaleDateString(getLocaleString(), dateOptions);
            let localWeekday = new Date(date).toLocaleDateString(getLocaleString(), weekdayOptions);
            return localWeekday + ', ' + (localDate = localDate.replace('.', '/').replace('.', '/'));
        },
        shortDateMonth(date, locale) {
            const dateOptions = { month: 'short', day: 'numeric' };
            let localDate = new Date(date).toLocaleDateString(locale || getLocaleString(), dateOptions);
            return localDate;
        },
        shortDateWithTime(date, locale) {
            const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
            const timeOptions = { hour: '2-digit', minute: '2-digit' };
            let localDate = new Date(date).toLocaleDateString(locale || getLocaleString(), dateOptions);
            let localTime = new Date(date).toLocaleTimeString(locale || getLocaleString(), timeOptions);
            return localDate + ', ' + localTime;
        },
        longDateWithTime(date, locale) {
            const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            const timeOptions = { hour: '2-digit', minute: '2-digit' };
            let localDate = new Date(date).toLocaleDateString(locale || getLocaleString(), dateOptions);
            let localTime = new Date(date).toLocaleTimeString(locale || getLocaleString(), timeOptions);
            return localDate + ', ' + localTime;
        },
    },
};
